import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { DialogContent, DialogTitle } from 'Views/Page/Content/Modal/Components';
import {
  FDBodyText,
  FDStack, FDTitleText,
} from '@facet-wealth/design';

const Layout = () => {
  const {
    resource,
  } = useMetaLayoutContext();

  return (
    <>
      <DialogTitle value={resource.attr('title')} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3}>
          {resource.attr('definitions').resources().list().map((definition) => (
            <FDStack direction="column">
              <FDTitleText value={definition.attr('title')} />
              <FDBodyText value={definition.attr('description')} />
            </FDStack>
          ))}
        </FDStack>
      </DialogContent>
    </>
  );
};

export default Layout;
